var map = {
	"./events-cat-cn.webp": 1997,
	"./events-cat.webp": 1998,
	"./games-cat.webp": 1999,
	"./live-casino-cat-cn.webp": 2000,
	"./live-casino-cat.webp": 2001,
	"./lottery-cat.webp": 2002,
	"./other-cat.webp": 2003,
	"./p2p-cat.webp": 2004,
	"./pd-table.webp": 2005,
	"./privacy-policy-title-bm.webp": 2006,
	"./privacy-policy-title-cn.webp": 2007,
	"./privacy-policy-title-id.webp": 2008,
	"./privacy-policy-title.webp": 2009,
	"./promos-1.webp": 2010,
	"./promos-2.webp": 2011,
	"./promos-3.webp": 2012,
	"./promos-4.webp": 2013,
	"./question.webp": 2014,
	"./sideBar-bg.webp": 2015,
	"./slot-cat-cn.webp": 2016,
	"./slot-cat.webp": 2017,
	"./special-cat-cn.webp": 2018,
	"./special-cat.webp": 2019,
	"./sports-cat-cn.webp": 2020,
	"./sports-cat.webp": 2021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;